import { render, staticRenderFns } from "./IncomingInvoice2.vue?vue&type=template&id=7b627bb7&"
import script from "./IncomingInvoice2.vue?vue&type=script&lang=js&"
export * from "./IncomingInvoice2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports